export default __webpack_public_path__ + "static/media/bedroom-2.9fada3cc.png";